import { type Type, Size, Color, FontType } from '../../../core/enums';
import makeAtom from '../../../core/makeAtom';
import type { Theme } from '../../../core/types';
import styles from './index.module.less';

type FlagTypes = Type | 'ribbon' | 'tag';

interface Props {
  Component?: keyof React.ReactHTML | React.ElementType;
  children?: React.ReactNode;
  className?: string;
  theme?: Theme;
  onClick?: any;
  $type?: FlagTypes;
  size?: Size;
  qeId?: string;
}

/**
 * getTagVariant.
 * @param {String} size - Flag type 'Tag' Size(XS | MD:default).
 * @return Tag's default properties depended on param Size. If no Size, it returns Medium size.
 */
export const getTagVariant = (size?: string) => {
  const DEFAULT_STYLES_TAG = {
    bgColor: Color.Black,
    borderColor: Color.Black,
    color: Color.White,
    rounded: Size.XXS,
    paddingTop: 0,
    paddingBottom: 0,
  };

  if (size === Size.XS) {
    return {
      ...DEFAULT_STYLES_TAG,
      minHeight: 18,
      paddingLeft: 3,
      paddingRight: 3,
      textLegal: 3,
    };
  }

  return {
    ...DEFAULT_STYLES_TAG,
    minHeight: 22,
    paddingLeft: 6,
    paddingRight: 6,
    textLegal: 4,
  };
};

/**
 * @deprecated
 * DEPRECATION NOTICE:
 * This component should not be used and will be removed [in V2](https://github.aexp.com/amex-eng/aqx-components/tree/next)
 *
 * Please upgrade to `RibbonV2` when possible.
 */
export const Badge = makeAtom<Props>({
  name: 'Badge',
  defaultProps: {
    Component: 'span',
    $type: 'primary',
  },
  rootClass: styles.root,
  styles,
  mapModifiersToTheme: ({ $type, size }): Theme => {
    const DEFAULT_STYLES = {
      rounded: Size.LG,
      paddingLeft: 15,
      paddingRight: 15,
      fontType: FontType.BentonMedium,
    };

    switch ($type) {
      case 'secondary':
        return {
          ...DEFAULT_STYLES,
          color: Color.BrightBlue,
          bgColor: Color.White,
          borderColor: Color.BrightBlue,
        };
      case 'tertiary':
        return {
          fontType: FontType.BentonMedium,
          color: Color.White,
          borderColor: Color.White,
        };
      case 'ribbon':
        return {
          bgColor: Color.Black,
          borderColor: Color.Black,
          color: Color.White,
          fontType: FontType.HelveticaBold,
          paddingLeft: 10,
          paddingRight: 15,
          rounded: Size.SM,
          textLegal: 2,
        };
      case 'tag':
        return getTagVariant(size);
      default: {
        // Primary
        return {
          ...DEFAULT_STYLES,
          color: Color.White,
          bgColor: Color.BrightBlue,
          borderColor: Color.BrightBlue,
        };
      }
    }
  },
  modifiersToDLSMap: {
    $type: {
      tertiary: [styles.underlined],
      ribbon: [styles.ribbon],
      tag: [styles.tag],
    },
  },
});
